<div class="home">
  <div class="router-column">
    <router-outlet></router-outlet>
  </div>
</div>
